import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
@Component({
  selector: 'app-advanced-settings-checkout-history',
  templateUrl: './advanced-settings-checkout-history.component.html',
  styleUrls: [
    './advanced-settings-checkout-history.component.scss',
    '../advanced-settings.component.scss'
  ],
})
export class AdvancedSettingsCheckoutHistoryComponent implements OnInit {

  constructor(
    private customerService: CustomerService,
    private cdr: ChangeDetectorRef
  ) { }

  public checkouts: any = {
    data: [],
    pagination: {
      total: 0,
      totalPages: 0,
      currentPage: 1,
      limit: 10
    }
  }

  ngOnInit(): void {
    this.initData();
  }

  ngAfterViewInit(): void {
  }

  initData(page: number = 1) {
    this.customerService.checkoutHistory({
      page: page,
      limit: this.checkouts.pagination.limit
    }).subscribe((res) => {
      this.checkouts = res.body;
      this.cdr.detectChanges();
    });
  }
}
